import { faUserTie } from '@fortawesome/free-solid-svg-icons'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { Roles } from '@/auth/azure/Roles'
import { TileRoleRoute } from '@/types'
import { Agent } from '@/routes/admin/users/agent/Agent'

export const AgentRoute = {
  path: 'agent',
  text: 'Commerciali',
  element: <Agent />,
  mainMenuRoute: false,
  faIcon: faUserTie,
  errorElement: <RouterErrorHandler />,
  handle: {
    crumb: () => ({
      label: 'Commerciali',
      icon: faUserTie,
    }),
  },
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
} satisfies TileRoleRoute
